import React from 'react';
import { Copy, Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import { Square } from '@grubhubprod/gh-cookbook-react/dist';
import { SSOEnableControl } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/SSOEnableControl/SSOEnableControl';
import { PasswordRestrictControl } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/PasswordRestrictedControl/PasswordRestrictControl';
import { ProviderConnectionIdControl } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/ProviderConnectionIdControl/ProviderConnectionIdControl';
import { SSOIdentifier } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/SSOIdentifier/SSOIdentifier';
import { UniqueIdentifierControl } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/UniqueIdentifierControl/UniqueIdentifierControl';
import { SSORedirectControl } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/SSORedirectControl/SSORedirectControl';
import { SSORedirectUrlControl } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/SSORedirectUrlControl/SSORedirectUrlControl';
import { useSSOWrapper } from 'src/components/enterprise/features/Corporate/components/Form/SSOWrapper/hooks/useSSOWrapper';

export function SSOWrapper(): JSX.Element {
  const {
    ssoEnabled,
    showUniqueIdentifier,
    ssoDisabled,
    passwordRestrictDisabled,
    showSsoOnNativeOption,
    showSsoRedirectUrl,
  } = useSSOWrapper();

  return (
    <>
      <SSOEnableControl
        name="ssoEnabled"
        id="ssoEnabled"
        disabled={ssoDisabled}
      />
      {ssoEnabled && (
        <Square bg="globals.white" inset="lg" dimension="1">
          <Row gutter={12}>
            <Column tablet={12} desktop={6} gutter={12}>
              <Stack y="sm">
                <ProviderConnectionIdControl
                  name="ssoProviderId"
                  id="ssoProviderId"
                />
              </Stack>
              <Stack y="sm">
                <SSOIdentifier name="ssoIdentifier" id="ssoIdentifier" />
              </Stack>
              {showUniqueIdentifier && (
                <Stack y="sm">
                  <UniqueIdentifierControl
                    name="ssoUniqueIdentifier"
                    id="ssoUniqueIdentifier"
                  />
                </Stack>
              )}
              <Stack y="x-sm">
                <Copy variant="body" strong>
                  Select the options the client would like to manage through SSO
                </Copy>
              </Stack>
              <Stack y="sm">
                <PasswordRestrictControl
                  name="passwordRestricted"
                  id="passwordRestricted"
                  disabled={passwordRestrictDisabled}
                />
                {showSsoOnNativeOption && (
                  <SSORedirectControl
                    name="ssoRedirectEnabled"
                    id="ssoRedirectEnabled"
                  />
                )}
                {showSsoRedirectUrl && (
                  <SSORedirectUrlControl
                    name="ssoRedirectUrl"
                    id="ssoRedirectUrl"
                  />
                )}
              </Stack>
            </Column>
          </Row>
        </Square>
      )}
    </>
  );
}
